import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { DomainsCard } from "@/modules/admin";

export default function AdminDomainsPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.domains.pageTitle")}
      description={t("admin.domains.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <DomainsCard />
      </PermissionGate>
    </AppLayout>
  );
}
